module.exports = __webpack_public_path__ + "img/itx-file-type-odc.87e9a49e.svg";